import m from "../../es2015/lang/lv_LV";
window.am4lang_lv_LV = m;


//////////////////
// WEBPACK FOOTER
// ./lang/lv_LV.js
// module id = null
// module chunks = 